import * as React from 'react';
import { useLocalize } from './localize-context';
import { Pill } from './pill';
import { VisitorContext } from './visitor-context';

export const VisitorTypeSwitcher = () => {
  const l = useLocalize();
  const [visitorType, setVisitorType] = React.useContext(VisitorContext);

  return (
    <div className="p-2 sm:p-4 flex justify-center">
      <div className="mx-4">
        <Pill
          onClick={() => setVisitorType('local')}
          active={visitorType === 'local'}
        >
          {l('Malaysian')}
        </Pill>
      </div>
      <div className="mx-4">
        <Pill
          onClick={() => setVisitorType('foreigner')}
          active={visitorType === 'foreigner'}
        >
          {l('Foreigner')}
        </Pill>
      </div>
    </div>
  );
};
